const API_URL = process.env.API_URL

function headers () {
  let headers = {
    'Content-Type': 'application/json',
    'timo-api-secret-v1': process.env.API_SECRET,
    'timo-api-key-v1': process.env.API_KEY
  }
  return headers
}

export async function getGuru (id) {
  let error = false
  let errorValue = {}
  let returnVal = await fetch(`${API_URL}/g/${id}/share`, {
    method: 'GET',
    headers: headers()
  }).catch(e => {
    error = true
    errorValue = {
      error: true,
      message: 'No Internet Connection',
      code: -1,
      type: 'NO_INTERNET'
    }
  })
  if (error) {
    return errorValue
  } else {
    return returnVal.json()
  }
}



// WEBPACK FOOTER //
// ./src/api.js